module.exports = __webpack_public_path__ + "img/balance.dabe0c54.png";